/**
 * Ce qu'est un événement « course », en un seul endroit.
 *
 * Cette page en tenait deux définitions contradictoires : le planning des
 * heats reconnaissait `course`, `running` et `trail`, tandis que la page des
 * courses et le menu ne reconnaissaient que `course`. Le désaccord était
 * silencieux — aucun événement n'a jamais porté `running` ni `trail`, le
 * formulaire de création n'ayant jamais proposé que `crossfit` et `course`
 * (vérifié en prod et en staging le 2026-09-09).
 *
 * Miroir de `cloud-api/api/core/event_access.py::TYPES_COURSE`.
 */

/** Les seuls types d'événement que le produit sait créer. */
export const EVENT_TYPES = ['crossfit', 'course'] as const;
export type EventType = (typeof EVENT_TYPES)[number];

/** Types qui partent en VAGUES et non en heats. */
const TYPES_COURSE = new Set<string>(['course']);

/**
 * Vrai pour un événement qui part en vagues.
 *
 * Le CrossFit est le défaut : c'est le cas courant, et le moins faux quand le
 * type n'a pas été transmis.
 */
export function isCourseEvent(eventType?: string | null): boolean {
  return TYPES_COURSE.has((eventType ?? '').toLowerCase());
}
